const DASHBOARD_RETRY_DELAY_MS = 1500;
const DASHBOARD_MAX_ATTEMPTS = 2;

/** 401s are handled globally (token refresh + reload); keep skeletons instead of flashing errors. */
export function isDashboardAuthPending(err) {
  return err?.response?.status === 401;
}

function isDashboardRetryableServerError(err) {
  const status = err?.response?.status;
  return Number.isFinite(status) && status >= 500 && status <= 599;
}

export function getDashboardErrorMessage(err, fallback) {
  if (isDashboardAuthPending(err)) return null;
  return err?.message || fallback;
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function fetchDashboardResource(requestFn, { attempts = DASHBOARD_MAX_ATTEMPTS } = {}) {
  let lastError;
  for (let attempt = 0; attempt < attempts; attempt++) {
    try {
      return await requestFn();
    } catch (err) {
      lastError = err;
      if (isDashboardAuthPending(err)) throw err;
      if (attempt < attempts - 1 && isDashboardRetryableServerError(err)) {
        await delay(DASHBOARD_RETRY_DELAY_MS);
        continue;
      }
      throw err;
    }
  }
  throw lastError;
}
